import React from "react";

export const CampaingMetaContext = React.createContext({
    parent: null,
});